/**
 * Bounded error label for a telemetry field.
 *
 * `error.name` or a bounded rejection-shape label, and nothing else. Every
 * `logger.*` on the cached-identity path
 * lands on the same Datadog sink and the sink applies no redaction to free
 * text, so an unbounded `message` is banned here: the rejection comes from
 * `auth_cached_identity_read`, whose Rust side resolves the account from the
 * keychain, and a Tauri IPC rejection routinely echoes the invoked payload or
 * the keychain entry name.
 *
 * `sanitizeError` is NOT the tool at this boundary. It projects to
 * `{ status, code }` off an axios shape, so a Tauri IPC rejection reaches the
 * sink as `{}` — redacted and useless. `useOfflineConnectivitySync` reached the
 * same conclusion at the same boundary; this is that helper, shared rather than
 * spelled out a third time.
 */
export const boundedErrorName = (error: unknown): string => {
  if (error instanceof Error) return error.name;
  // Rust `Err(String)` values cross the Tauri IPC boundary as bare strings.
  // The value is unbounded and cannot be logged; its shape is safe and useful.
  return typeof error === 'string' ? 'RejectedString' : 'UnknownError';
};
